import React from 'react';
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers';
import { useFormContext, Controller } from 'react-hook-form';
import InputLabel from '@mui/material/InputLabel';
import cx from 'classnames';
import styles from '@/common/components/Inputs/DatePicker/styles.less';
import dayjs from 'dayjs';
import {
  PICKER_DATE_FORMAT,
  PICKER_DATE_PLACEHOLDER,
  ReactBB,
} from '@/common/utils/index';
const DEFAULT_MIN_DATE = new Date(1900, 0, 1);

const DatePicker = ({
  className,
  name,
  label,
  tip,
  required,
  inputFormat = PICKER_DATE_FORMAT,
  format,
  rules,
  maxDate,
  minDate,
  ...props
}) => {
  const { control } = useFormContext() || {};

  return (
    <div className={cx(styles.container, className)}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({
          field: { onChange, onBlur, value, name, ref },
          fieldState: { error },
        }) => {
          const parsedValue = value ? dayjs(value) : null;
          const fieldValue = parsedValue?.isValid()
            ? parsedValue.toDate()
            : null;
          const parsedMaxDate = maxDate ? dayjs(maxDate) : null;
          const parsedMinDate = minDate
            ? dayjs(minDate)
            : dayjs(DEFAULT_MIN_DATE);

          return (
            <>
              <InputLabel
                className={cx(styles.label, error && styles['label-error'])}
                htmlFor={name}
              >
                {ReactBB(label)}
                {required && <span className={styles.labelRequired}>*</span>}
              </InputLabel>
              <MUIDatePicker
                format={format || inputFormat}
                value={fieldValue}
                onChange={(nextValue) => {
                  if (!nextValue || !dayjs(nextValue).isValid()) {
                    onChange(null);
                    return;
                  }

                  onChange(dayjs(nextValue).toDate());
                }}
                maxDate={
                  parsedMaxDate?.isValid() ? parsedMaxDate.toDate() : undefined
                }
                minDate={
                  parsedMinDate?.isValid() ? parsedMinDate.toDate() : undefined
                }
                disableFuture
                slotProps={{
                  textField: {
                    name,
                    className: cx(styles.input),
                    helperText: error?.message || tip,
                    error: !!error,
                    fullWidth: true,
                    onBlur,
                    inputRef: ref,
                    sx: {
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '4px',
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderRadius: '4px',
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: '16px 12px',
                      },
                    },
                    ...props,
                    inputProps: {
                      ...props.inputProps,
                      placeholder:
                        props.inputProps?.placeholder ||
                        PICKER_DATE_PLACEHOLDER,
                      'data-testid': name,
                    },
                  },
                }}
              />
            </>
          );
        }}
      />
    </div>
  );
};

export default DatePicker;
